import type { FilterComponentProps } from '@/app/common/filters/core/filterComponentType.ts';
import type { FilterDataSwitch } from '@/app/common/filters/core/filtersTypes.ts';
import { FilterBadgeContent } from '@/app/common/filters/surfaces/badges/FilterBadgeContent.tsx';

export const FilterSwitchBadge = ({ filter, isLoading, handleFilterChanged }: FilterComponentProps) => {
  const filterData = filter.data as FilterDataSwitch;
  const { label } = filterData;

  const handleFilterClicked = () => {
    const updatedFilter = {
      ...filter,
      data: {
        ...filter.data,
        selected: false,
      },
    };
    handleFilterChanged([updatedFilter]);
  };

  return <FilterBadgeContent label={label} handleFilterClicked={handleFilterClicked} isLoading={isLoading} />;
};
